var _path, _g, _rect, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 132,
    viewBox: "0 0 64 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3942 12.858L31.3952 12.8574C31.7189 12.6553 32.1507 12.6399 32.4993 12.8574L32.5002 12.858L40.8317 18.0395L40.8324 18.04C41.0573 18.1794 41.1942 18.4257 41.1942 18.6905V30.9131C41.1942 31.1274 41.0207 31.3 40.8083 31.3H35.3004V27.3209C35.3004 25.4646 33.8039 23.9658 31.9467 23.9658C30.0899 23.9658 28.5943 25.4649 28.5943 27.3209V31.3H23.0858C22.8735 31.3 22.7 31.1274 22.7 30.9131V18.6905C22.7 18.4255 22.8372 18.1789 23.0612 18.0394L31.3942 12.858Z",
    stroke: "#50595F",
    strokeWidth: 1.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0245 56.2636L22.6914 61.4451C22.2617 61.7125 22 62.184 22 62.6905V74.9131C22 75.5136 22.4864 76 23.0858 76H28.7514C29.0511 76 29.2943 75.7568 29.2943 75.4565V71.3209C29.2943 69.8507 30.4773 68.6658 31.9467 68.6658C33.4169 68.6658 34.6004 69.8507 34.6004 71.3209V75.4565C34.6004 75.7568 34.8436 76 35.1433 76H40.8083C41.4077 76 41.8942 75.5136 41.8942 74.9131V62.6905C41.8942 62.184 41.6325 61.7125 41.2014 61.4451L32.8699 56.2636C32.2844 55.8982 31.5647 55.9264 31.0245 56.2636Z",
    fill: "url(#paint0_linear_1_201)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 88,
    width: 64,
    height: 44,
    fill: "#3C82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0245 100.264L22.6914 105.445C22.2617 105.712 22 106.184 22 106.691V118.913C22 119.514 22.4864 120 23.0858 120H28.7514C29.0511 120 29.2943 119.757 29.2943 119.457V115.321C29.2943 113.851 30.4773 112.666 31.9467 112.666C33.4169 112.666 34.6004 113.851 34.6004 115.321V119.457C34.6004 119.757 34.8436 120 35.1433 120H40.8083C41.4077 120 41.8942 119.514 41.8942 118.913V106.691C41.8942 106.184 41.6325 105.712 41.2014 105.445L32.8699 100.264C32.2844 99.8982 31.5647 99.9264 31.0245 100.264Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_201",
    x: 18,
    y: 54,
    width: 27.8942,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.223529 0 0 0 0 0.729412 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_201",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_201",
    x1: 31.9471,
    y1: 56,
    x2: 31.9471,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d55d1c32fb7a572253f0450483ac3c70.svg";
export { ForwardRef as ReactComponent };